import { RootState } from "core-integration/src/store";
import {
  getElement,
  getElementsEventDataById,
} from "core-integration/src/store/elements/reducers";
import { getFixturesForTeamInEvent } from "core-integration/src/store/fixtures/reducers";
import { Fragment, ReactNode } from "react";
import { useSelector } from "react-redux";
import { visuallyHidden } from "../../styles/utils.css";
import { FixtureForElement } from "../FixtureForElement";
import { elementMultiPoints } from "./elementPoints.css";
import { ElementPointsProps } from "./types";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";

const pointsWithLabel = (points: number, pointsText: string) => (
  <span>
    {points}
    <span className={visuallyHidden}> {pointsText}</span>
  </span>
);

const ElementPoints = ({ eventId, pick }: ElementPointsProps) => {
  const { points: pointsText } = usePlosTranslations();
  const element = useSelector((state: RootState) =>
    getElement(state, pick.element),
  );
  const fixturesForTeam = useSelector((state: RootState) =>
    getFixturesForTeamInEvent(state, eventId, element.team),
  );
  const elementsEventDataById = useSelector((state: RootState) =>
    element ? getElementsEventDataById(state, eventId) : null,
  );

  if (!element || !elementsEventDataById) {
    return null;
  }

  const elementEventData = elementsEventDataById[element.id];

  const explainList = elementEventData.explain;
  const totalPoints =
    elementEventData.stats.total_points * Math.max(pick.multiplier, 1);

  if (explainList.length === 1) {
    return pointsWithLabel(totalPoints, pointsText);
  }

  const fragments: React.ReactNode[] = [];
  let started = 0;

  explainList.forEach((e) => {
    const fixture = fixturesForTeam.find((f) => f.id === e.fixture);
    if (fixture) {
      if (!fixture.started) {
        fragments.push(
          <FixtureForElement element={element} fixture={fixture} />,
        );
      } else {
        started++;
      }
    }
  });
  if (started) {
    fragments.unshift(pointsWithLabel(totalPoints, pointsText));
  }
  if (fragments.length === 0) {
    return null;
  }
  const itemsWithSeparators: ReactNode[] = [];
  fragments.forEach((node, i) => {
    if (i > 0) itemsWithSeparators.push(", ");
    itemsWithSeparators.push(node);
  });
  const withSeparators = itemsWithSeparators.map((node, i) => (
    <Fragment key={i}>{node}</Fragment>
  ));

  return <div className={elementMultiPoints}>{withSeparators}</div>;
};

export default ElementPoints;
